/* eslint-disable react-hooks/exhaustive-deps */
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDown } from 'components/InputsMex/inputs';
import EmisionFooterBarButtons from 'components/Polizas/EmisionFooterBarButtons';
import { predicateBuscarValidaciones } from 'containers/Polizas/utils/funciones';
import useCustomForm from 'hooks/useCustomForm';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import React, { useEffect } from 'react';
import { Controller, FormProvider } from 'react-hook-form';
import useAsegurados from 'redux/hooks/emision/useAsegurados';
import BeneficiariosTable from './BeneficiariosTable';
import Seccion from './Seccion';

const Form = () => {
  const {
    parentescoFormAdd,
    catalogoForm,
    setShowFormAdd,
    guardarInformacion,
    getPorcentajes,
  } = useAsegurados();
  const { codProducto } = useQueryParams();

  const { addWarningToast } = useCustomToast();

  const methods = useCustomForm({ mode: 'onChange' });

  useEffect(() => {
    methods.reset(catalogoForm.asegurado);
  }, []);

  const onSubmit = async (formData) => {
    formData.parentezco = parentescoFormAdd.value;
    formData.parentezcoLabel = parentescoFormAdd.label;
    formData.estadoIngreso = 'COMPLETADO';
    formData.datosCompletos = true;
    console.log('DATA: ', formData);

    const validaciones = catalogoForm.validaciones
      .filter(
        predicateBuscarValidaciones(
          formData?.tipoPersona?.value,
          codProducto,
          'asegurados',
        ),
      )
      .map((validacion) =>
        methods.validate(validacion.name, validacion.onSubmitRules),
      )
      .filter((validacion) => !validacion);

    if (validaciones?.length && validaciones.length > 0) {
      return addWarningToast('Rellene el formulario correctamente');
    }

    return await guardarInformacion(formData, false);
  };

  const onSubmitError = (formData) => {
    console.log(formData);
  };

  const onClickAtras = () => setShowFormAdd(false);

  const onGuardar = async () => {
    const formData = methods.getValues();
    formData.parentezco = parentescoFormAdd.value;
    formData.parentezcoLabel = parentescoFormAdd.label;
    formData.estadoIngreso = 'PENDIENTE';
    formData.datosCompletos = false;

    const valid = await methods.trigger('tipoPersona');

    if (valid) {
      await guardarInformacion(formData, false);
    } else {
      addWarningToast('Debe seleccionar un tipo de persona');
    }
  };

  return (
    <FormProvider {...methods}>
      <div className="row my-5 justify-content-center">
        <div className="col-11 col-sm-12 col-md-11 card-login-mex">
          <div className="row my-4">
            <div className="col-12 text-center">
              <h3>Agregar asegurado {parentescoFormAdd?.label}</h3>
              {parentescoFormAdd.value === 'hijo' && (
                <h6 className="ml-4">
                  * Solo se pueden asegurar hijos dependientes económicos
                </h6>
              )}
            </div>
            <div className="col-md-6 col-lg-5 mt-5">
              <SimpleContainer label="Tipo de persona" name="tipoPersona">
                <DropDown
                  rules={{ required: 'Obligatorio' }}
                  name="tipoPersona"
                  options={catalogoForm?.tipoPersona}
                />
              </SimpleContainer>
            </div>

            {methods.watch('tipoPersona')?.value &&
              catalogoForm?.secciones?.map((item) => (
                <Seccion key={item.codigo} {...item} />
              ))}

            <div className="col-lg-11 mx-auto">
              <Controller
                name="beneficiarios"
                defaultValue={[]}
                rules={{
                  validate: (value) => {
                    if (value?.length === 0) {
                      return 'Obligatorio';
                    }

                    if (getPorcentajes(value).disponible !== 0) {
                      return 'Debe completar el 100% de porcentaje';
                    }

                    return true;
                  },
                }}
                render={({ value, onChange }) => (
                  <BeneficiariosTable beneficiarios={value} setter={onChange} />
                )}
              />
            </div>
          </div>
        </div>
      </div>
      <EmisionFooterBarButtons
        onClickAtras={onClickAtras}
        onClickGuardar={onGuardar}
        onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
      />
    </FormProvider>
  );
};

export default Form;
